export default __webpack_public_path__ + "static/media/7_home-image.94e47dcf.jpg";